import React from 'react';

const Alumni = () => {
  return (
    <div>
      Alumni
      Alumni
    </div>
  );
}

export default Alumni;
